module.exports = __webpack_public_path__ + "static/qualite.a07bac02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/qualite.png
// module id = 811
// module chunks = 34885888655430